import { Link } from 'react-router-dom';
import { articlePages } from '@/mocks/homeData';

export default function ArticleCards() {
  const primaryArticles = articlePages.slice(0, 8);
  const secondaryArticles = articlePages.slice(8, 16);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            In-Depth BaseTao Resources
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Original research and practical guides to help you make informed
            decisions about BaseTao Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {primaryArticles.map((article, index) => (
            <Link
              key={article.path}
              to={article.path}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-200 overflow-hidden"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${article.icon} text-sm text-primary-600`}></i>
                  </div>
                  <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-700 transition-colors duration-200">
                    {article.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center gap-1.5 text-xs text-primary-600 font-medium mt-auto">
                  Read Article
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-5">
          {secondaryArticles.map((article, index) => (
            <Link
              key={article.path}
              to={article.path}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-200 overflow-hidden"
              style={{ animationDelay: `${(index + 8) * 80}ms` }}
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${article.icon} text-sm text-accent-600`}></i>
                  </div>
                  <h3 className="font-heading text-sm text-foreground-900 group-hover:text-accent-700 transition-colors duration-200">
                    {article.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center gap-1.5 text-xs text-accent-600 font-medium mt-auto">
                  Read Article
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}